




























import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { MedTransGoConstants } from '@/util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest, QueryRecordsRequest } from '@/types/request';
import { DriverProfile } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import ConfirmationBox from '../../components/ConfirmationBox.vue';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';


@Component({
    props: {
        requestId: String,
        routeId: String,
    },
    mixins: [validationMixin],
    components: {
        ConfirmationBox,
    },
    data() {
        return {
            driverId: '',
        };
    },
    validations: {
        driverId: {
            required,
        },
    },
})
export default class AssignDriverModal extends Vue {
    private show = true;
    private showConfirmBox = false;
    private drivers: DriverProfile[] = [];
    public mounted() {
        this.getDrivers(0);
    }

    private async assignDriver(requestId: string, routeId: string) {
        const driverId = this.$data.driverId;
        const request: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            data: {
                requestId,
            },
            url: `${MedTransGoConstants.HTTP_URL_ROUTES}/${routeId}/${driverId}/assign`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await ObjectFactory.getHttpService().put<string>(request);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'Driver Assigned Successfully',
                title: 'Driver Assigned!',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
            this.close();
        }
    }

    private async getDrivers(start?: number) {
        const iHttpService = ObjectFactory.getHttpService();
        const queryRecordsRequest: QueryRecordsRequest = {
            conditions: [{
                op: 'eq',
                fieldName: 'status',
                value: 'ACTIVE',
            }, {
              op: 'eq',
              fieldName: 'requestId',
              value: this.$props.requestId,
            }],
            limit: MedTransGoConstants.DB_QUERY_MAX_RESULT,
            start,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            data: queryRecordsRequest,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/driver/list`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<DriverProfile[]>(apiRequest);
        if (response.data && response.success) {
            this.drivers = response.data;
        } else {
            CommonUtils.showError(response);
        }
    }

    private close() {
        this.$emit('close');
    }
}
